import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaClipboardList } from "react-icons/fa6";
import { FaPrayingHands } from "react-icons/fa";
import MandalAdminLayout from "../../../components/MandalAdminLayout/MandalAdminLayout";

export default function MandalInfo() {
  const location = useLocation();
  const { id } = location?.state || {};
  const navigate = useNavigate();

  console.log(`id: ${id}`);

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "MandalAdmin") {
      navigate("/");
    }
  }, [navigate]);

  return (
    <MandalAdminLayout ac8="active" id={id}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h4 className="m-0 text-dark">Mandal Information</h4>
            </div>
          </div>
        </div>
      </div>
      <section className="content mb-4">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-sm-6 col-md-4">
              <div
                className="info-box mb-3"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  navigate("/manage-haribhakt2", { state: { id: id } })
                }
              >
                <span className="info-box-icon bg-danger elevation-1">
                  <FaPrayingHands />
                </span>
                <div className="info-box-content">
                  <span className="info-box-text pb-1">Mandal Haribhakt</span>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <div
                className="info-box mb-3"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/attendance2", { state: { id: id } })}
              >
                <span className="info-box-icon bg-warning elevation-1">
                  <FaClipboardList />
                </span>
                <div className="info-box-content">
                  <span className="info-box-text pb-1">Mandal Attendance</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </MandalAdminLayout>
  );
}
